
let newsletterPopup = document.querySelector('.newsletter-popup');
let newsletterCloseBtns = document.querySelectorAll('.close-popup');


if(!localStorage.getItem("popup-viewed") && typeof Storage !== "undefined") {
    setTimeout(() => {
        newsletterPopup.classList.add('show-popup');
      }, popupTiming);
}


if (window.location.href.indexOf("customer_posted=true#popup") > -1) {
    newsletterPopup.classList.add('show-popup');
}


newsletterCloseBtns.forEach((item) => {
    item.addEventListener('click', (event) => {
        newsletterPopup.classList.remove('show-popup');
        localStorage.setItem("popup-viewed", "true");
    });
});